import ObjectBuilderInterface from "@/modules/api/object-builder.interface";

import QuestionTemplateProductRelation from "./question-template-product-relation.model";

export default class QuestionTemplateProductRelationFactory
  implements ObjectBuilderInterface<QuestionTemplateProductRelation> {
  public buildFromJSON(data: {
    [key: string]: any;
  }): QuestionTemplateProductRelation {
    const value = new QuestionTemplateProductRelation(
      data.id,
      data.template,
      data.productId.toString()
    );

    value.isNew = false;

    return value;
  }
}
